import React, { useState, useEffect } from "react";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { advget } from "$ACTIONS/TlcRequest";
import moment from "moment";
import MyPromotionList from "@/MyPromotionTabs/List";
import showMessage from "$ACTIONS/messageUtil";
import showPromotionErrorModal from "@/Promotion/UI";
import { showResultPopup } from "$ACTIONS/helper";
import CancellationModal from "@/MyPromotionTabs/InProgress/CancellationModal";
import Newbie from "@/Newbie";
import useFetchAppliedHistory from "@/MyPromotionTabs/hooks/useFetchAppliedHistory";

const InProgress = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isChecking, setIsChecking] = useState(false);
    const [isModalVisible, setModalVisible] = useState(false);
    const [modalData, setModalData] = useState(null); // 传递给 CancellationModal 的数据
    const [inProgressPromotions, setInProgressPromotions] = useState([]);

    const { promotions, loading } = useFetchAppliedHistory("inProgress");

    useEffect(() => {
        setInProgressPromotions(promotions);
    }, [promotions]);

    const removePromotion = (playerBonusId) => {
        setInProgressPromotions((prev) => prev.filter((item) => item.playerBonusId !== playerBonusId));
    };

    const handleCardAction = async (item, actionType) => {
        if (actionType === "cancel") {
            Pushgtagdata("Bonus", "Cancel Bonus", "Bonus_C_Cancel");

            if (item?.bonusCategory === "Signup Bonus") {
                showResultPopup({
                    type: "confirm",
                    title: "ยืนยันการยกเลิกโปรโมชั่น",
                    content:
                        "โปรโมชั่นนี้สามารถขอรับได้เพียงครั้งเดียวเท่านั้น\nหากยกเลิกจะไม่สามารถขอรับใหม่ได้",
                    okText: "ฝากตอนนี้",
                    cancelText: "ปิด",
                    onOk: () => initiateCancellationFlow(item),
                    onCancel: () => {},
                });
            } else {
                // Directly proceed with cancellation
                initiateCancellationFlow(item);
            }
        }
    };

    const initiateCancellationFlow = async (item) => {
        try {
            setIsChecking(true);

            if (item?.bonusRuleType === "PRE") {
                const eligibilityRes = await advget(
                    `${ApiPort.GETBonusCancellationEligibility}&playerBonusId=${item?.playerBonusId}`
                );

                const { isSuccess, result } = eligibilityRes || {};
                const { errorCode, message: apiMessage, data: unfinishInfo } = result || {};

                if (isSuccess) {
                    // 打开 CancellationModal，传入 type 和数据
                    const { pullbackAmount = 0, bonusGivenAmount = 0, winningAmount = 0, isTurnoverProgress } = result;

                    setModalData({
                        type: "PRE",
                        data: {
                            pullbackAmount,
                            bonusGivenAmount,
                            winningAmount,
                            isTurnoverProgress,
                            playerBonusId: item?.playerBonusId,
                        },
                    });
                    setModalVisible(true);
                } else {
                    if (errorCode === "BP00120") {
                        const { productVendors, productGroupName } = unfinishInfo || {};
                        const productText = productVendors?.length > 1 ? productGroupName : productVendors?.[0];
                        showPromotionErrorModal(errorCode, apiMessage, productText);
                    } else {
                        showPromotionErrorModal(errorCode, apiMessage);
                    }
                }
            } else {
                // 打开 POST 类型的 CancellationModal
                setModalData({
                    type: "POST",
                    data: {
                        playerBonusId: item?.playerBonusId,
                    },
                });
                setModalVisible(true);
            }
        } catch (error) {
            console.error("Error initiating cancellation flow:", error);
            showMessage("info", "โปรดลองอีกครั้งในภายหลัง", 80);
        } finally {
            setIsChecking(false);
        }
    };

    // 关闭 Modal 方法
    const handleModalClose = () => {
        setModalVisible(false);
        setModalData(null);
    };

    const renderImportantNote = () => (
        <div className="important-note">
            <p className="important-note-title">การแจ้งเตือนที่สำคัญ</p>
            <p className="important-note-content">
                1. หลังจากที่คุณปฏิบัติตามเงื่อนไขโบนัสสำหรับโบนัสแล้ว โปรดคลิก
                [กดรับโบนัส] เพื่อยืนยันการรับโบนัส
                <br />
                2. หากไม่ปฏิบัติตามเงื่อนไขโบนัสภายในเวลาที่กำหนด{" "}
                <span className="highlight-bold">โบนัสปรับก่อน</span>{" "}
                จะถูกดึงคืนโดยอัตโนมัติ
            </p>
        </div>
    );

    return (
        <>
            <MyPromotionList
                promotions={inProgressPromotions}
                loading={loading || isLoading || isChecking}
                type="inProgress"
                renderImportantNote={renderImportantNote}
                onCardActionClick={handleCardAction}
                lastUpdatedTime={moment()
                    .utcOffset(8)
                    .format("DD/MM/YYYY HH:mm [GMT+8]")}
                showTabs={true}
                showDatePicker={false}
            />
            {/* 渲染 CancellationModal */}
            {isModalVisible && (
                <CancellationModal
                    visible={isModalVisible}
                    type={modalData?.type}
                    data={modalData?.data}
                    onClose={handleModalClose}
                    onSuccess={removePromotion}
                />
            )}
            <Newbie
                imgsrc="/th/img/newbie/MyBonus.webp"
                imgstyle={{
                    width: 1250,
                    maxWidth: "100vw",
                    marginLeft: -625,
                    top: 112,
                    left: "50%",
                }}
                btnstyle={{ top: 678 }}
            />
        </>
    );
};

export default InProgress;
